import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const crearOEditarActividad = async (actividad) => {
    try {
        if (actividad.id) {
            const resp = await axios.post(
                `${API_URL}/actividades/editar/${actividad.id}`,
                actividad,
                { headers: getHeaders() }
            );

            return resp.data;
        }

        const resp = await axios.post(`${API_URL}/actividades`, actividad, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarActividad = async (id_actividad) => {
    try {
        const resp = await axios.delete(
            `${API_URL}/actividades/${id_actividad}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarActividad = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/actividades/activar/${data.id}`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectActividad = async (sedeAreaLider) => {
    try {
        const resp = await axios.post(
            `${API_URL}/actividades/select`,
            sedeAreaLider,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const asignarActividadCuadroTurno = async (
    idCuadroTurno,
    actividad
) => {
    try {
        const resp = await axios.post(
            `${API_URL}/actividades/${idCuadroTurno}/asignar`,
            { actividad },
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const editarAsignacionDeSubAreas = async (
    id_persona,
    crear,
    eliminar
) => {
    try {
        const resp = await axios.put(
            `${API_URL}/subareas/${id_persona}/editarAsignacion`,
            { crear, eliminar },
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const actividadesPorColaborador = async (id_cuadro_turno) => {
    try {
        const resp = await axios.get(
            `${API_URL}/actividades/actividadColaborador/${id_cuadro_turno}`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const asignarActividadesColaboradores = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/actividades/asignarActividades`,
            data,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
